import { ApiBind, Common } from './common.model';

export class DeliverySetSdkVersionGroup extends Common {
  @ApiBind({ column: 'sdk_version_group_id' })
  id: number;
}
